$(function () {
  $(document).on('click', '#lan-ld-26-card .item.special', function (e) {
    e.preventDefault();
    $('.popup-avatar').addClass('active');
  });

  $(document).on('click', '.popup-avatar', function () {
    $('.popup-avatar').removeClass('active');
  });
});
